import React from 'react';
import { Modal } from 'react-bootstrap';
import { AuthenticatedImage } from './AuthenticatedImage';
import { FileData } from '../utils/fileUtils';

interface ImageModalProps {
  show: boolean;
  onHide: () => void;
  fileData: FileData;
  filename: string;
}

/**
 * Modal for displaying fullsize images
 */
export const ImageModal: React.FC<ImageModalProps> = ({ show, onHide, fileData, filename }) => {
  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>{filename}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        {fileData.url ? (
          <AuthenticatedImage
            url={fileData.url}
            alt={filename}
            style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }}
          />
        ) : fileData.data ? (
          <img
            src={`data:${fileData.mimeType};base64,${fileData.data}`}
            alt={filename}
            style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }}
          />
        ) : null}
      </Modal.Body>
    </Modal>
  );
};
